// data/languages/yoruba/categories/famille.ts
//
// Le yoruba distingue l'âge plutôt que le sexe : ẹ̀gbọ́n = aîné(e),
// àbúrò = cadet(te). On précise ọkùnrin (homme) ou obìnrin (femme) au besoin.

import { CategoryData } from '../../../../types/types';

export const famille: CategoryData = {
  'Ẹbí': { translation: 'Famille', translationEn: 'Family', illustration: '👨🏿‍👩🏿‍👧🏿‍👦🏿' },
  'Òbí': { translation: 'Parent (père ou mère)', translationEn: 'Parent', illustration: '👪🏿' },
  'Ìyá': { translation: 'Mère', translationEn: 'Mother', illustration: '👩🏿' },
  'Bàbá': { translation: 'Père', translationEn: 'Father', illustration: '👨🏿' },
  'Ìyá àgbà': { translation: 'Grand-mère', translationEn: 'Grandmother', illustration: '👵🏿' },
  'Bàbá àgbà': { translation: 'Grand-père', translationEn: 'Grandfather', illustration: '👴🏿' },
  'Ẹ̀gbọ́n': { translation: 'Aîné(e) (frère ou sœur plus âgé)', translationEn: 'Older sibling', illustration: '🧑🏿' },
  'Àbúrò': { translation: 'Cadet(te) (frère ou sœur plus jeune)', translationEn: 'Younger sibling', illustration: '🧒🏿' },
  'Ẹ̀gbọ́n ọkùnrin': { translation: 'Frère aîné', translationEn: 'Older brother', illustration: '👦🏿' },
  'Ẹ̀gbọ́n obìnrin': { translation: 'Sœur aînée', translationEn: 'Older sister', illustration: '👧🏿' },
  'Ọmọ': { translation: 'Enfant', translationEn: 'Child', illustration: '👶🏿' },
  'Ọmọkùnrin': { translation: 'Fils / Garçon', translationEn: 'Son / Boy', illustration: '👦🏿' },
  'Ọmọbìnrin': { translation: 'Fille', translationEn: 'Daughter / Girl', illustration: '👧🏿' },
  'Ọmọ ọmọ': { translation: 'Petit-enfant (litt. « enfant d\'enfant »)', translationEn: 'Grandchild (lit. "child of child")', illustration: '👶🏿' },
  'Ìbejì': { translation: 'Jumeaux (très honorés chez les Yoruba)', translationEn: 'Twins (highly honoured among the Yoruba)', illustration: '👯🏿' },
  'Ọkọ': { translation: 'Mari', translationEn: 'Husband', illustration: '🤵🏿' },
  'Ìyàwó': { translation: 'Épouse / Mariée', translationEn: 'Wife / Bride', illustration: '👰🏿' },
  'Àbúrò bàbá': { translation: 'Oncle ou tante (cadet du père)', translationEn: 'Uncle or aunt (father\'s younger sibling)', illustration: '🧔🏿' },
  'Àbúrò ìyá': { translation: 'Oncle ou tante (cadet de la mère)', translationEn: 'Uncle or aunt (mother\'s younger sibling)', illustration: '👩🏿' },
  'Àna': { translation: 'Beau-parent / Belle-famille', translationEn: 'In-law', illustration: '🤝🏿' },
  'Ìbátan': { translation: 'Parent éloigné / Membre de la famille', translationEn: 'Relative', illustration: '🧑🏿‍🤝‍🧑🏿' },
  'Ọ̀rẹ́': { translation: 'Ami(e)', translationEn: 'Friend', illustration: '🤗' },
};

export default famille;
